import { useDisplayVariant } from 'modules/productDetail'
import * as React from 'react'
import styled from 'styled-components'
import Link from 'theme/atoms/Link'
import config from 'config'

export default function DisposalOfLegacyDevice() {
  const variant = useDisplayVariant()

  if (
    !variant.data.attributes?.DISPOSAL_OF_LEGACY_DEVICE ||
    !config.features.disposalOfLegacyDevice
  )
    return null

  return (
    <Wrapper
      className="DisposalOfLegacyDevice"
      data-cy-state="show-legacy-device-info"
    >
      <Link
        to={config.features.disposalOfLegacyDevice as string}
        onKeyDown={(e) => {
          if (e.key === ' ') {
            e.preventDefault()
            window.location.href = config.features
              .disposalOfLegacyDevice as string
          }
        }}
      >
        <DisposalDevice
          $imgSrc={
            config.modules.cloudinary.endpoint +
              variant.data.attributes.DISPOSAL_OF_LEGACY_DEVICE.values[0]
                .icon || ''
          }
          $title={variant.data.attributes.DISPOSAL_OF_LEGACY_DEVICE.label}
        />
      </Link>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: end;
`

type DisposalLegacyAttributesProps = {
  $title: string
  $imgSrc: string
}

const DisposalDevice = styled.figure.attrs<DisposalLegacyAttributesProps>(
  (p) => ({
    title: p.title
  })
)`
  display: inline-block;
  margin: 0;
  width: 177px;
  height: 45px;
  background-image: url(${(p: DisposalLegacyAttributesProps) => p.$imgSrc});
  background-repeat: no-repeat;
  background-size: contain;
`
